import React, { useEffect, useRef } from 'react';
import MessageItem from './MessageItem';

export const MessageList = ({
  messages,
  avatarImage,
  aiAssistantName: _aiAssistantName,
  userName,
  groupJoinRequest,
  friendRequest,
  onAcceptJoin,
  onRejectJoin,
  onViewChatLog,
  onIgnoreFriend,
  onAcceptFriend,
  onIgnoreChatLog,
  t,
  userId,
  onMessageDeleted,
  chatType = 'private'
}) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const aiDisplayName = `${userName || '用户'}的AI分身`;

  return (
    <div
      className="flex-1 overflow-y-auto no-scrollbar pt-4 px-4 space-y-6 safe-bottom relative z-10"
      style={{ paddingBottom: 'calc(100px + env(safe-area-inset-bottom))' }}
    >
      {messages.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-[var(--neon-primary)] text-sm font-medium animate-pulse">{t.sayHello}</p>
        </div>
      ) : (
        messages.map((msg) => (
          <MessageItem
            key={msg.id}
            msg={msg}
            avatarImage={avatarImage}
            aiAssistantName={aiDisplayName}
            groupJoinRequest={groupJoinRequest}
            friendRequest={friendRequest}
            onAcceptJoin={onAcceptJoin}
            onRejectJoin={onRejectJoin}
            onViewChatLog={onViewChatLog}
            onIgnoreFriend={onIgnoreFriend}
            onAcceptFriend={onAcceptFriend}
            onIgnoreChatLog={onIgnoreChatLog}
            userId={userId}
            onMessageDeleted={onMessageDeleted}
            chatType={chatType}
          />
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
